import type {
    TransportRequestCrudContextLike,
    TransportRequestFormContextLike,
    TransportRequestPermissions,
    TransportRequestRelationRef,
    TransportRequestStatusRef,
} from '@/Containers/TransportationSection/Components'
import type { UserLike } from '@/Ship/Helpers/fieldViews'

/** Ключ ресурсу запиту — під ним його відкривають реєстр, канбан, пошук і вкладка клієнта. */
export const REQUEST_RESOURCE = 'Transportation.Request'

/** Колекція запитів (`SPEC-022` §6). */
export const REQUEST_REST_URL = '/services/requests'

/** Крок 1 двокрокового завантаження файлу запиту (`SPEC-022` §4.4). */
export const REQUEST_FILE_UPLOAD_URL = '/services/request_files'

/** Довідник статусів запитів (`SPEC-007`): рядок статусів, колонки канбану, бейджі підказки. */
export const REQUEST_STATUS_RESOURCE = 'Setting.ListRequestStatus'

/** Довідник причин програшу запитів — варіанти модалки «Програти». */
export const REQUEST_LOSS_REASON_RESOURCE = 'Setting.ListRequestLossReason'

/** Ширина шухляди картки — як у картки клієнта (два стовпці блоків). */
export const REQUEST_DRAWER_WIDTH = 1200

/** Системні коди статусів запиту (`RequestStatusCode` беку). */
export const REQUEST_STATUS_CODES = {
    new: 'request-new',
    price: 'request-price',
    application: 'request-application',
    loss: 'request-loss',
} as const

/** Запис запиту так, як його віддають картка й колекція (лише те, що читає фронт). */
export interface RequestRecord {
    uuid?: string
    '@id'?: string
    id?: number
    title?: string
    client?: TransportRequestRelationRef | null
    status?: TransportRequestStatusRef | null
    responsible?: UserLike | null
    loadingCountries?: TransportRequestRelationRef[] | null
    unloadingCountries?: TransportRequestRelationRef[] | null
    typesCars?: TransportRequestRelationRef[] | null
    addressLoading?: string | null
    addressUnloading?: string | null
    cargo?: string | null
    offeredPrice?: number | null
    closingAt?: string | null
    lossReason?: TransportRequestRelationRef | null
    createdAt?: string | null
    countOffers?: number | null
    _permissions?: TransportRequestPermissions
}

/** Відповідь колекції `GET /services/requests`. */
export interface RequestCollectionResponse {
    items?: RequestRecord[]
    meta?: { total?: number }
}

export type RequestFormContextLike = TransportRequestFormContextLike
export type RequestCrudContextLike = TransportRequestCrudContextLike
